module.exports = require("plugin-liverig/shared/hooks/useKeys");